import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Autosuggest from 'react-autosuggest';

import Button from 'src/components/buttons/button';
import { performSearch } from 'src/utils/router';
import api from 'src/utils/api';
import i18n from 'src/utils/translate';
import { throttle } from 'lodash';

class SearchBar extends Component {
  static propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    onSearch: PropTypes.func,
  }

  static defaultProps = {
    className: null,
    onClick: () => {},
    onSearch: () => {},
  }

  constructor(props) {
    super(props);
    this.state = {
      focus: false,
      query: '',
      suggestions: [],
    };
  }

  onFocus = () => {
    this.setState({ focus: true });
  }

  onBlur = () => {
    this.setState({ focus: false });
  }

  onClick = () => {
    this.props.onClick();
  }

  handleSubmit = (e) => {
    document.activeElement.blur();
    if (e) e.preventDefault();

    performSearch(this.state.query);
    this.props.onSearch();
    this.setState({ focus: false, query: '' });
  }

  onSuggestionsFetchRequested = throttle(async ({ value = '' }) => {
    if (value.length <= 1) {
      return;
    }
    const { data } = await api.getPublic(`search/autocomplete?q=${value}`);
    this.setState({
      // TODO: remove toLowerCase when the b/e is fixed
      suggestions: data.slice(0, 10).map(x => x.toLowerCase()),
    });
  }, 500);

  onSuggestionsClearRequested = () => {
    this.setState({ suggestions: [] });
  }

  onSuggestionSelected = (e, { suggestion }) => {
    this.setState({ query: suggestion }, () => {
      this.handleSubmit();
    });
  }

  renderInputComponent = (props) => {
    const inputContainerClassName = classNames({
      'search-bar__container': true,
      'search-bar__container--focused': this.state.focus,
    });
    const customProps = {
      ...props,
      'aria-label': i18n.t('Start a search'),
      ref: (node) => {
        this.input = node;
        props.ref(node);
      },
    };
    return (
      <label className={inputContainerClassName}>
        <input {...customProps} />
        <Button
          className="search-bar__icon solo-icon"
          disabled={!this.state.query}
          icon="search-1"
          isSubmit={true}
          text={<span className="search-bar__submit-text">{ i18n.t('Search') }</span>}
        />
      </label>
    );
  }

  renderSuggestion = (text) => {
    const highlight = this.state.query;
    // queries with special characters (e.g. 'Pregnancy (difficulties)') were breaking the RegExp so they are now escaped
    const escapedHighlight = highlight.replace(/[-[\]{}()*+?.,\\^$|#]/g, '\\$&');
    const parts = text.split(new RegExp(`(${escapedHighlight})`, 'gi'));
    return (
      <span>
        {parts.map((part, i) =>
          <span
            key={i}
            style={part.toLowerCase() === highlight.toLowerCase() ? { fontWeight: 'bold' } : {}}
          >
            {part}
          </span>)}
      </span>
    );
  }

  render() {
    const containerClassName = classNames({
      'search-bar': true,
      [this.props.className]: !!this.props.className,
    });
    const inputProps = {
      className: 'search-bar__input',
      placeholder: i18n.t('Search HealthUnlocked'),
      onChange: (e, { newValue }) => {
        this.setState({ query: newValue });
      },
      value: this.state.query,
      type: 'text',
      onBlur: this.onBlur,
      onClick: this.onClick,
      onFocus: this.onFocus,
    };

    return (
      <div className={containerClassName}>
        <form
          className="search-bar__form"
          onSubmit={this.handleSubmit}
        >
          <Autosuggest
            getSuggestionValue={suggestion => suggestion}
            id={`site-search${this.props.customId}`}
            inputProps={inputProps}
            renderInputComponent={this.renderInputComponent}
            renderSuggestion={this.renderSuggestion}
            suggestions={this.state.suggestions}
            title="site-search"
            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
            onSuggestionSelected={this.onSuggestionSelected}
            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          />
        </form>
      </div>
    );
  }
}

export default SearchBar;
